import client from '../httpClient';

const libraryDeleteApi = (libraryId) => {
  return client.delete(`/libraries/management/${libraryId}`);
};

export default libraryDeleteApi;
